<template>
  <section class="px-16 mt-8">
    <loading-flux :value="loadingActions"></loading-flux>
    <v-row>
      <v-col cols="12" md="12" sm="12" v-if="showHeader">
        <section class="d-flex flex-column flex-sm-row justify-content-between">
          <h2 class="my-3">Solicitar Hes</h2>
        </section>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <v-autocomplete
          class="mt-3"
          placeholder="Filtrar por Unidad de Negocio"
          v-model="filters.business_unit"
          :items="activeBusinessUnits"
          item-text="name"
          item-value="code"
          clearable
          @change="($event) => getOcWithHesData()"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <v-text-field
          label="Búsqueda (N° de OC)"
          @input="($event) => getOcWithHesData()"
          v-model="filters.filter"
          clearable
          class="mt-3"
          placeholder="Búsqueda (N° de OC)"
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <v-text-field
          label="Búsqueda (Nombre o RUT del Proveedor)"
          @input="($event) => getOcWithHesData()"
          v-model="filters.supplier_filter"
          clearable
          class="mt-3"
          placeholder="Búsqueda (Nombre o RUT del Proveedor)"
          append-icon="mdi-account-search"
        ></v-text-field>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <v-autocomplete
          v-model="filters.items"
          class="mt-3"
          :items="[5, 10, 15, 20, 25, 100]"
          label="Items por Página"
          @change="($event) => getOcWithHesData()"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" lg="4" md="4" sm="12" class="pt-0">
        <v-autocomplete
          v-model="filters.status"
          class="mt-6"
          @change="($event) => getOcWithHesData()"
          :items="listStatusPayment"
          label="Filtrar por Estatus de Servicio"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="12" sm="12" class="mb-2">
        <v-data-table
          :page.sync="filters.page"
          :headers="wrappedTableHeaders"
          :items="ocWithHes.items ? ocWithHes.items : []"
          item-key="id"
          :items-per-page="filters.items"
          class="elevation-2"
          mobile-breakpoint="993"
          hide-default-footer
          :loading="loading"
          no-data-text="No hay Datos para Mostrar"
          loading-text="Cargando Ordenes... Espere Por favor"
          show-expand
          :key="keyTableHes"
          :expanded.sync="expanded"
          @update:sort-by="updateSortBy"
          @update:sort-desc="updateSortDesc"
        >
          <template v-slot:item="{ item, isExpanded }">
            <tr @click="clickedRow(item)">
              <td>
                <div class="d-flex align-items-center justify-content-center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        class="blue lighten-1 text-white"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ item.sap_code }}
                      </v-chip>
                    </template>
                    <span>{{ item.description }}</span>
                  </v-tooltip>
                </div>
              </td>
              <td>
                <span v-if="item.created_at != null">{{
                  formatDateToHuman(item.created_at)
                }}</span>
              </td>
              <td>
                <div class="text-left">
                  {{ item.project ? item.project.name : item.cost_center.name }}
                  {{ item.project ? `| ${item.stage_code}` : "" }}
                </div>
              </td>
              <td>
                <div class="text-left">
                  {{ item.sap_supplier ? item.sap_supplier.code : "" }}
                </div>
              </td>
              <td>
                <div class="text-right">
                  {{
                    item.total_before_tax
                      ? `$ ${new Intl.NumberFormat("de-DE").format(
                          Number(item.total_before_tax)
                        )}`
                      : "-"
                  }}
                  CLP
                </div>
              </td>
              <td>
                <div class="text-right">
                  {{
                    item.tax
                      ? `$ ${new Intl.NumberFormat("de-DE").format(
                          Number(item.tax)
                        )} CLP`
                      : "-"
                  }}
                </div>
              </td>
              <td>
                <div class="text-right">
                  {{
                    item.total
                      ? `$ ${new Intl.NumberFormat("de-DE").format(
                          Number(item.total)
                        )} CLP`
                      : "-"
                  }}
                </div>
              </td>
              <td>
                <div class="text-right">
                  {{
                    getTotalAmountPayOc(item) !== "N/A"
                      ? `$ ${new Intl.NumberFormat("de-DE").format(
                          Number(getTotalAmountPayOc(item))
                        )} CLP`
                      : "N/A"
                  }}
                </div>
              </td>
              <td>
                <v-progress-linear
                  rounded
                  :value="getTotalPercentageOc(item)"
                  color="light-green darken-1"
                  class=""
                  height="25"
                >
                  <template v-slot:default="{ value }">
                    <strong
                      style="font-size: 12px"
                      :class="Math.ceil(value) == 100 ? 'text-white' : ''"
                      >{{
                        value.toLocaleString("es-ES", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      }}%
                    </strong>
                  </template>
                </v-progress-linear>
              </td>
              <td>
                <v-icon>
                  {{ isExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
                </v-icon>
              </td>
            </tr>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="bg-gray">
              <section class="my-5 px-3">
                <table-services-oc-hes
                  @emitOpenModalItemsHes="openModalItemsHes"
                  @emitOpenModalGenerateHes="openModalGenerateHes"
                  ref="tableServicesOcHes"
                  :request-service="item"
                  class="mt-5"
                ></table-services-oc-hes>
              </section>
            </td>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            color="blue lighten-1"
            v-model="filters.page"
            :length="ocWithHes ? ocWithHes.number_of_pages : 1"
            :total-visible="8"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <modal-items-hes
      :modalAction="dialogItemsHes"
      :closeModalItemsHes="closeModalItemsHes"
      :currentServiceWithHes="currentServiceHes"
    >
    </modal-items-hes>
    <generate-hes
      :modalAction="dialogGenerateHes"
      :closeModalGenerateHes="closeModalGenerateHes"
      :currentServiceWithHes="currentServiceHes"
      @hesGenerated="getOcWithHesData"
    ></generate-hes>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { formatDateMomentToHuman } from "@/helpers/common";
import roles from "@/mixins/roles";
import { authUsuarioComputed } from "@/state/helpers";
import {
  ACTIVE_BUSINESS_UNITS,
  COST_CENTER_PURCHASE,
  COST_CENTER_PURCHASE_MANAGMENT,
} from "@/constants/common";
import ModalItemsHes from "./components/ModalItemsHes.vue";
import GenerateHes from "./components/GenerateHes.vue";
import {
  HES_STATUS_LIST,
  HES_STATUS_PAY,
  HES_STATUS_PENDING,
  HES_STATUS_PARTIAL,
  HES_STATUS_PAY_TEXT,
  getAllHes,
} from "@/constants/supplying/hes";
import TableServicesOcHes from "./components/TableServicesOcHes.vue";
import { OC_CREATED_IN_PLATFORM } from "@/constants/supplying/hes";
export default {
  components: { ModalItemsHes, GenerateHes, TableServicesOcHes },
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [roles],
  data() {
    return {
      keyTableHes: 999,
      currentServiceHes: null,
      loading: false,
      loadingActions: false,
      debounce: null,
      debounceTime: 500,
      dialogItemsHes: false,
      dialogGenerateHes: false,
      listStatusPayment: HES_STATUS_LIST,
      HES_STATUS_PAY,
      HES_STATUS_PAY_TEXT,
      HES_STATUS_PENDING,
      HES_STATUS_PARTIAL,
      filters: {
        page: 1,
        items: 10,
        filter: "",
        supplier_filter: null,
        status: null,
        business_unit: null,
        sort_by: "created_at",
        sort_order: "desc",
      },
      expanded: [],
      tableHeaders: [
        {
          value: "sap_code",
          text: "N° de OC",
          sortable: true,
          align: "center",
          width: "3%",
        },
        {
          value: "created_at",
          sortable: true,
          align: "center",
          text: "Fecha Creación",
          width: "8%",
        },
        {
          value: "project",
          text: "Proyecto/CECO",
          align: "start",
          sortable: true,
          width: "10%",
        },
        {
          value: "sap_supplier",
          text: "Proveedor",
          align: "start",
          sortable: true,
          width: "10%",
        },
        {
          value: "total_before_tax",
          text: "Monto Neto",
          align: "end",
          sortable: false,
          width: "10%",
        },
        {
          value: "tax",
          text: "IVA",
          align: "end",
          sortable: false,
          width: "10%",
        },
        {
          value: "total",
          text: "Monto Total",
          align: "end",
          sortable: true,
          width: "10%",
        },
        {
          value: "total",
          text: "Monto Emitido",
          align: "end",
          sortable: false,
          width: "10%",
        },
        {
          value: "percentage",
          text: "Total Pago Completado",
          align: "center",
          sortable: false,
          width: "5%",
        },
        {
          text: "Servicios",
          align: "center",
          sortable: false,
          value: "data-table-expand",
          width: "3%",
        },
      ],
    };
  },
  mounted() {
    this.getOcWithHesData();
    this.getBusinessUnits();
  },
  methods: {
    ...mapActions({
      getAllOcWithHes: "supplying/getAllOcWithHes",
      getBusinessUnits: "document/getBusinessUnits",
    }),
    clickedRow(value) {
      if (this.expanded.find((item) => item.id == value.id)) {
        return (this.expanded = this.expanded.filter(
          (item) => item.id !== value.id
        ));
      }
      this.expanded.push(value);
    },
    async getOcWithHesData(page = 1) {
      clearTimeout(this.debounce);
      let self = this;
      // self.keyTableHes = self.keyTableHes + 1;
      this.debounce = await setTimeout(async function() {
        self.loading = true;
        self.filters.page = page;
        await self.getAllOcWithHes({
          page,
          is_service: true,
          filter: self.filters.filter ? self.filters.filter : undefined,
          supplier_filter: self.filters.supplier_filter
            ? self.filters.supplier_filter
            : undefined,
          un_filter: self.filters.business_unit
            ? self.filters.business_unit
            : undefined,
          status_filter: self.filters.status ? self.filters.status : undefined,
          user_filter:
            self.currentUserIsSuperAdmin || self.userHavePurchaseCeco
              ? undefined
              : self.user.email,
          items: self.filters.items,
          plataforma_filter: OC_CREATED_IN_PLATFORM,
          sort_by: self.filters.sort_by,
          sort_order: self.filters.sort_order,
        });
        self.loading = false;
      }, self.debounceTime);
    },
    formatDateToHuman(date) {
      return formatDateMomentToHuman(date);
    },
    openModalItemsHes(item) {
      this.currentServiceHes = item;
      this.dialogItemsHes = true;
    },
    closeModalItemsHes() {
      this.dialogItemsHes = false;
      this.currentServiceHes = null;
    },
    openModalGenerateHes(item) {
      this.currentServiceHes = item;
      this.dialogGenerateHes = true;
    },
    closeModalGenerateHes() {
      this.dialogGenerateHes = false;
      this.currentServiceHes = null;
    },
    getPercentageOc(service, totalAmountOc) {
      if (service.status === HES_STATUS_PAY_TEXT) {
        return 100;
      }
      let totalAmount = 0;
      getAllHes(service).forEach((hes) => {
        totalAmount += hes.quantity * (service.total / service.quantity);
      });
      return (totalAmount / totalAmountOc) * 100;
    },
    getTotalPercentageOc({ total_before_tax: totalAmountOc, items: services }) {
      if (!services.length) {
        return 0;
      }
      const totalPercentage = services.reduce((total, service) => {
        return total + this.getPercentageOc(service, service.total);
      }, 0);

      return totalPercentage > 100 ? 100 : totalPercentage;
    },
    getTotalAmountPayOc({ total, items: services }) {
      let totalAmount = 0;
      if (services.find((service) => service.status === HES_STATUS_PAY_TEXT)) {
        return total;
      }
      if (services.find((service) => service.currency !== "CLP")) {
        return "N/A";
      }
      services.forEach((service) => {
        getAllHes(service).forEach((hes) => {
          totalAmount += hes.quantity * (service.total / service.quantity);
        });
      });
      return totalAmount;
    },
    async updateSortBy(sortBy) {
      if (sortBy) {
        this.filters.sort_by = sortBy == "sap_supplier" ? "supplier" : sortBy;
        this.filters.sort_order = "asc";
        await this.getOcWithHesData();
      } else {
        this.filters.sort_by = "created_at";
        this.filters.sort_order = "desc";
        await this.getOcWithHesData();
      }
    },
    async updateSortDesc(sortDesc) {
      if (sortDesc) {
        this.filters.sort_order = "desc";
        await this.getOcWithHesData();
      }
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      ocWithHes: "supplying/ocWithHes",
      businessUnits: "document/businessUnits",
      dataEmployees: "maintainers/employeeInfoUser",
    }),
    userHavePurchaseCeco() {
      if (
        this.dataEmployees.employees.length &&
        this.dataEmployees.employees.find(
          (employee) =>
            employee.cost_center.code == COST_CENTER_PURCHASE ||
            employee.cost_center.code == COST_CENTER_PURCHASE_MANAGMENT
        )
      ) {
        return true;
      }
      return false;
    },
    activeBusinessUnits() {
      // return this.businessUnits.filter((item) =>
      //   ACTIVE_BUSINESS_UNITS.includes(item.name)
      // );
      return this.businessUnits;
    },
    wrappedTableHeaders() {
      return this.tableHeaders;
    },
  },
  watch: {
    "filters.page"(newValue) {
      this.getOcWithHesData(newValue);
    },
  },
};
</script>

<style></style>
